import React from 'react';
import PropTypes from 'prop-types';
import { Prompt } from 'react-router';

const message = 'You have unsaved changes, are you sure you want to leave?';

const SaveBeforeExit = ({ hasChanges }) => (
  <React.Fragment>
    <Prompt
      when={hasChanges}
      message={message}
    />
  </React.Fragment>
);

SaveBeforeExit.propTypes = {
  hasChanges: PropTypes.bool.isRequired,
};

export default SaveBeforeExit;


// WEBPACK FOOTER //
// ./src/components/save-before-exit/SaveBeforeExit.jsx